import axiosConfig from '../axiosConfig';
import { InsightsActionsRequest, InsightsActionsResponse, GenericResponse } from '../types';
import {
	LambdaDashboardSummaryRequest,
	LambdaGraphSummariesRequest,
} from '../types/lambda-graph-summaries-request';
import {
	LambdaDashboardSummaryResponse,
	LambdaGraphSummariesResponse,
} from '../types/lambda-graph-summaries-response';

export class InsightsActions {
	public static GetInsights(
		request: InsightsActionsRequest,
		isDashboardInsights = false
	): Promise<GenericResponse<InsightsActionsResponse>> {
		let url = 'app/ai/insights-actions';

		if (isDashboardInsights) {
			url += '?isDashboardInsights=true';
		}
		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<InsightsActionsResponse>;
		});
	}

	public static GetGraphSummariesInsights(
		request: LambdaGraphSummariesRequest
	): Promise<GenericResponse<LambdaGraphSummariesResponse[]>> {
		const url = 'app/ai/graph-summary';

		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<LambdaGraphSummariesResponse[]>;
		});
	}

	public static GetDashboardSummaryInsights(
		request: LambdaDashboardSummaryRequest
	): Promise<GenericResponse<LambdaDashboardSummaryResponse>> {
		const url = 'app/ai/dashboard-summary';

		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<LambdaDashboardSummaryResponse>;
		});
	}
}
